import { useQuery } from '@tanstack/react-query';
import { getExpenseInvoiceDocuments } from '../Services/ExpenseService';

const useGetExpenseInvoiceDocuments = (params, options) =>
    useQuery({
        queryKey: ['getExpenseInvoiceDocuments', params],
        queryFn: () => getExpenseInvoiceDocuments(params),
        enabled: !!params?.expenseId,
        ...options,
    });

export default useGetExpenseInvoiceDocuments;
